module.exports = __webpack_public_path__ + "static/media/rightImg1.3cd4b173.png";